import React from "react";
import pedicureTreatmentDryImg from "./../../../../../Images/Blog/Best Pedicure Treatments for Dry and Cracked Heels/Banner.png";

const PedicureTreatmentDryImg = () => {
  return (
    <div className="pediManicureImg">
      <img
        src={pedicureTreatmentDryImg}
        alt="pedicureTreatmentDryImg"
        loading="lazy"
      />
    </div>
  );
};

export default PedicureTreatmentDryImg;
